import JWPlayer from './jwplayer'

customElements.define('atype-video-jwplayer', JWPlayer)
